module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('div', {
    staticClass: "fx filter-wapper"
  }, [_c('div', {
    staticClass: "fx fx-wrap fx-fill"
  }, [_c('div', {
    staticClass: "fx-shrink"
  }, [_c('z-select', {
    staticClass: "w150",
    attrs: {
      "options": _vm.statusItem
    },
    on: {
      "handleChange": _vm.handleGetOrderList
    },
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fx fx-wrap fx-fill"
  }, [_c('div', {
    staticClass: "fx fx-wrap m-l-10"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "align": "left",
      "placeholder": "选择下单时间范围",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.handleSetTime
    },
    model: {
      value: (_vm.orderTime),
      callback: function($$v) {
        _vm.orderTime = $$v
      },
      expression: "orderTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "fx-shrink"
  }, [_c('z-search', {
    attrs: {
      "placeholder": "请输入订单号 / 微信昵称..."
    },
    on: {
      "handleSearch": _vm.handleGetOrderList
    },
    model: {
      value: (_vm.params.search),
      callback: function($$v) {
        _vm.$set(_vm.params, "search", $$v)
      },
      expression: "params.search"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "classify-table"
  }, [_c('z-table', {
    attrs: {
      "offset": _vm.params.offset,
      "count": _vm.params.count,
      "total-count": _vm.list.item_total
    },
    on: {
      "handleOffset": _vm.handleOffset
    }
  }, [_vm._l((_vm.columns), function(item, index) {
    return _c('th', {
      attrs: {
        "slot": "columns"
      },
      slot: "columns"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(item) + "\n\t\t\t\t"), (index == 2) ? _c('a', {
      staticClass: "arrow m-l-5",
      class: [_vm.params.orderBy == 'pay_fee:ASC' ? 'up-sort' : _vm.params.orderBy == 'pay_fee:DESC' ? 'down-sort' : ''],
      on: {
        "click": function($event) {
          return _vm.handleListByOrder('pay_fee')
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.list.list || []), function(item, index) {
    return _c('tr', {
      attrs: {
        "slot": "datasource"
      },
      slot: "datasource"
    }, [_c('td', [_vm._v(_vm._s(item.order_no))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nickname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("filterMoney")(item.pay_money)))]), _vm._v(" "), _c('td', {
      class: [item.status == 1 ? 'success' : item.status == 3 ? 'fail' : 'ing']
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("filterOrderStatus")(item.status)) + "\n\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("momentFmt")(item.c_time)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("momentFmt")(item.pay_time)))]), _vm._v(" "), _c('td', {
      staticClass: "operating"
    }, [_c('router-link', {
      staticClass: "operat-btn",
      attrs: {
        "tag": "a",
        "to": {
          name: 'vOrderDetail',
          query: {
            id: item.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "icon-look"
    }), _c('span', [_vm._v("查看详情")])])], 1)])
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0ed0bc70","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/vmall/Order.vue
// module id = 815
// module chunks = 0